<template>
    <div id="courses-container">
        <router-view class="main"></router-view>
    </div>
</template>

<script>
export default {
    name: 'courses',
    data() {
        return {
            route: this.$route.name
        }
    },
}
</script>

<style scoped>
/* ----------------------------------- */
/* ------------ Container ------------ */
/* ----------------------------------- */
#public-container {
    width: 100%;
    min-height: 100vh;
}
</style>